import React, { useState, useEffect } from 'react';
import './FloatingText.css';

export type EffectType = 'damage' | 'crit' | 'block' | 'dodge' | 'heal' | 'victory' | 'defeat' | 'reduced';

interface FloatingTextProps {
  id: number;
  text: string;
  type: EffectType;
  position: { x: number; y: number };
  onComplete: (id: number) => void;
}

const FloatingText: React.FC<FloatingTextProps> = ({ id, text, type, position, onComplete }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Victory and defeat messages should not disappear automatically
    if (type === 'victory' || type === 'defeat') {
      return;
    }

    const timer = setTimeout(() => {
      setVisible(false);
      // Give time for the fade-out animation
      setTimeout(() => onComplete(id), 500);
    }, 1500);

    return () => clearTimeout(timer);
  }, [id, onComplete, type]);

  const className = `floating-text ${type} ${visible ? 'visible' : ''}`;

  return (
    <div className={className} style={{ left: `${position.x}px`, top: `${position.y}px` }}>
      {text}
    </div>
  );
};

export default FloatingText;
